import * as React from "react";
import DocumentsCardFileUpload from "./DocumentsCardFileUpload";
import DocumentsCardReadySend from "./DocumentsCardReadySend";
import { OutotecIcons } from "../Icons";
import { DROPFILES, acceptedFileFormats } from "../../../Constants";

declare var require: any;
const Dropzone: any = require("react-dropzone");

interface IFileUploadProps {
    isRemoving?: boolean;
    isUploading?: boolean;
    multiple?: boolean;

    onDrop: (acceptedFiles: File[], rejectedFiles: File[]) => any;
}

const FileUpload: React.FC<IFileUploadProps> = (props: IFileUploadProps) => {
    var dropZoneContent: JSX.Element;
    if (props.isUploading) {
        dropZoneContent = <span>Uploading...</span>;
    } else if (props.isRemoving) {
        dropZoneContent = <span>Removing...</span>;
    } else {
        dropZoneContent = (
            <div className="Dropzone__content">
                <OutotecIcons type={DROPFILES} />
                <div>Drag and drop files here</div>
                <div>or</div>
                <button className="btn btn-secondary">UPLOAD FILE</button>
                {/*Decorator(dummy) button. Area handle click*/}
            </div>
        );
    }

    return (
        <div className="Dropzone">
            <Dropzone
                className="Dropzone__area"
                disablePreview={false} // get local blob uri to file
                accept={acceptedFileFormats}
                multiple={props.multiple ? props.multiple : true}
                onDrop={(acceptedFiles: File[], rejectedFiles: File[]) =>
                    props.onDrop(acceptedFiles, rejectedFiles)
                }
            >
                {dropZoneContent}
            </Dropzone>
        </div>
    );
};

export default FileUpload;

export { DocumentsCardFileUpload, DocumentsCardReadySend };
